
function GradientLine() {
  return (
    <div className="h-[1px] my-[1rem] bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
  );
}

export default GradientLine;
